import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home'; // Import Home component
import ScrollTopButton from './Components/ScrollTopButton';
//import GenAssistantHome from './Components/InnerPages/GenAssistantHome';
import ArtificialIntelligence from './Components/ArtificialIntelligence';
import ExploreAIStrategyAdvisory from './Components/ExploreAIStrategyAdvisory';
import Leadership from './Components/Leadership';
import ContactUs from './Components/ContactUs';
import Lab from './Components/720DegreesLab';
import Careers from './Components/Careers';
import InvestorsFaq from './Components/InvestorsFaq';
import TermsPageP from './Components/TermsPageP';
import TermsPageE from './Components/TermsPageE';
import TermsPageS from './Components/TermsPageS';
import SearchResults from './Components/SearchResults';


function App() {
  return (
    <Router>
      <div className="mainsection-outer">
        <ScrollTopButton/>
        <Routes>
          <Route path="/" element={<Home />} /> {/* /home Route */}
          <Route path="/0/:pagename/:id" element={<ArtificialIntelligence />} />
          <Route path="/0/details/:pagename/:id" element={<ExploreAIStrategyAdvisory />} />
          <Route path="/1/:pagename/:id" element={<Lab />} />
          <Route path="/leadership/:pagename/:id" element={<Leadership />} />
          <Route path="/investors-faq/:pagename/:id" element={<InvestorsFaq />} /> 
          <Route path="/careers/:pagename/:id" element={<Careers />} />
          <Route path="/contact-us" element={<ContactUs />} />
          {
            localStorage.getItem('lang')==='es'?
            <Route path="/terms-page" element={<TermsPageS />} />
            : localStorage.getItem('lang')==='br' ? 
              <Route path="/terms-page" element={<TermsPageP />} />
            : <Route path="/terms-page" element={<TermsPageE />} />
          }
          <Route path="/search" element={<SearchResults />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
